export class NumberStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const value = JSON.parse(data);
            this.assertValid(value);
            return value;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        if (typeof data !== "number" || data === null) {
            throw new Error("Invalid number value");
        }
    }
}
